import {
  ApiResponse,
  ApplicationRequest,
  ApplicationResponse,
} from '../types/api';
import { ENCRYPTION_CONFIG } from '../constants';
import { encryptApplicantsIdNo } from '../../utils/crypto';
import { lifeApi } from './base';

type PostApplicationArgs = {
  body: ApplicationRequest;
  skipEncryption?: boolean;
};

const postApplication = lifeApi.injectEndpoints({
  endpoints: (builder) => ({
    postApplication: builder.mutation<
      ApiResponse<ApplicationResponse>,
      PostApplicationArgs
    >({
      queryFn: async (args, _queryApi, _extraOptions, baseQuery) => {
        const { body, skipEncryption = false } = args;

        const applicants = skipEncryption
          ? body.applicants
          : await encryptApplicantsIdNo(body.applicants, ENCRYPTION_CONFIG);

        const requestBody: ApplicationRequest = {
          ...body,
          applicants,
        };

        const result = await baseQuery({
          url: '/',
          method: 'POST',
          body: requestBody,
          params: {
            relativeUrl: 'applications',
          },
        });

        return result.data
          ? { data: result.data as ApiResponse<ApplicationResponse> }
          : { error: result.error };
      },
    }),
  }),
});

export const { usePostApplicationMutation } = postApplication;
